/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { ClientTeamSummary } from './';
import {
    ClientTeamSummaryFromJSON,
    ClientTeamSummaryFromJSONTyped,
    ClientTeamSummaryToJSON,
} from './';

/**
 * 
 * @export
 * @interface ClientTeamsResource
 */
export interface ClientTeamsResource {
    /**
     * 
     * @type {Array<ClientTeamSummary>}
     * @memberof ClientTeamsResource
     */
    clientTeams: Array<ClientTeamSummary>;
}

/**
 * Check if a given object implements the ClientTeamsResource interface.
 */
export function instanceOfClientTeamsResource(value: object): value is ClientTeamsResource {
    if (!('clientTeams' in value) || value['clientTeams'] === undefined) return false;
    return true;
}

export function ClientTeamsResourceFromJSON(json: any): ClientTeamsResource {
    return ClientTeamsResourceFromJSONTyped(json, false);
}

export function ClientTeamsResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClientTeamsResource {
    if (json == null) {
        return json;
    }
    return {
        
        'clientTeams': ((json['clientTeams'] as Array<any>).map(ClientTeamSummaryFromJSON)),
    };
}

export function ClientTeamsResourceToJSON(value?: ClientTeamsResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'clientTeams': ((value['clientTeams'] as Array<any>).map((v) => ClientTeamSummaryToJSON(v))),
    };
}

